import { render, staticRenderFns } from "./royalties_table.vue?vue&type=template&id=06bb9629&scoped=true&"
import script from "./royalties_table.vue?vue&type=script&lang=js&"
export * from "./royalties_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb9629",
  null
  
)

export default component.exports